/**
 * Profiles — API client.
 * Mirrors src/lib/supabase/profiles.ts function signatures exactly.
 */
import { apiGet, apiPatch } from './client';

export type { Profile } from '@/lib/supabase/profiles';

import type { Profile } from '@/lib/supabase/profiles';

export async function fetchProfiles(_orgId: string | null): Promise<Profile[]> {
  return apiGet<Profile[]>('/api/profiles');
}

export async function updateProfile(
  id: string,
  patch: { role?: string; shift?: string | null; team?: string | null; active?: boolean },
): Promise<void> {
  await apiPatch<void>(`/api/profiles/${id}`, patch);
}
